import { styled } from 'baseui'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { FlexCenter } from '@/shared/theme/styled-components'

export const StyledTitle = styled('h3', ({ $theme }) => ({
  flexGrow: 1,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontFamily: 'Family/Body',
  fontWeight: 600,
  fontSize: '16px',
  letterSpacing: '-1.4%',
  color: $theme.colors.textHeading,
  height: 'auto',
}))

export const CreateAddressButton = styled(SDButton, ({ $theme }) => ({
  borderRadius: '.375rem',
  border: `1px solid ${$theme.colors.primaryAlt}`,
  backgroundColor: 'transparent',
  fontSize: '0.875rem',
  color: $theme.colors.primary400,
  textAlign: 'center',
  marginTop: '.5rem',
  ':hover': {
    backgroundColor: $theme.colors.primary400,
    color: $theme.colors.white,
  },
}))

export const CreateAddressButtonContainer = styled(FlexCenter, {
  height: '2rem',
  padding: '.25rem .75rem',
  gap: '.375rem',
  marginBottom: '1rem',
})

export const MultipleInputsContainer = styled('div', () => ({
  display: 'flex',
  gap: '1rem',
}))
